import { createSelector } from 'reselect';

import { VIEWS_KEY, ViewsState } from './reducers';

const selectViewsState = (state: any): ViewsState => state.get(VIEWS_KEY);

export const selectCurrentView = createSelector(selectViewsState, state => state.current);

export const selectCurrentViewType = createSelector(selectCurrentView, view => view?.type);

export const selectCurrentViewID = createSelector(selectCurrentView, view => view?.viewId);

export const selectPreviousView = createSelector(
    selectViewsState,
    (state): ViewsState | undefined => state.previous,
);

export const selectViewTransition = createSelector(
    selectViewsState,
    state => state.transition || 'push',
);
